import { createContext } from "react";
import Keycloak from "keycloak-js";
import type { KeycloakConfig } from "keycloak-js";
import { IdleTimerProvider } from "react-idle-timer";
import { TIMEOUT } from "../app/utils/constants";

export const KeycloakContext = createContext<Keycloak | null>(null);
export const { Consumer } = KeycloakContext;

type IProps = {
  children: React.ReactNode;
  authServerUrl: string;
  tenantId: string;
  clientId: string;
};

export const AuthProvider = (props: IProps) => {
  const keycloakConfig: KeycloakConfig = {
    url: props.authServerUrl,
    realm: props.tenantId,
    clientId: props.clientId,
  };

  // Create the instance
  const keycloak = new Keycloak(keycloakConfig);

  const ContextProvider = KeycloakContext.Provider as any;

  return (
    <IdleTimerProvider
      timeout={TIMEOUT}
      crossTab
      onIdle={() => keycloak.logout()}
    >
      <ContextProvider value={keycloak}>
        {props.children}
      </ContextProvider>
    </IdleTimerProvider>
  );
};